@if (automation$ | async; as automation) {
  <div class="flex items-center">
    @if (withCheckbox) {
      <div (click)="$event.stopPropagation()">
        <mat-checkbox
          color="primary"
          [checked]="checked$ | async"
          (change)="checkedChange.emit($event)"
        />
      </div>
    }

    <pr-automation-icon [automation]="automation.data" />

    <div class="flex grow flex-col px-4">
      <div class="title">
        <pr-content-text [content]="title$ | async" />
      </div>

      <div class="text-xs opacity-50">
        From: {{ automation.creator.name }}
        <mat-icon
          class="icon-3"
          [matTooltip]="automation.creator.type | splitCamel | titlecase"
        >
          info
        </mat-icon>
      </div>
    </div>

    @if (triggerDate$ | async; as triggerDate) {
      <div
        class="w-[76px] text-right text-xs"
        matTooltip="New trigger date calculated from new event time"
        [ngClass]="{ 'new-date': isNewTriggerDate$ | async }"
      >
        {{ triggerDate | moment | amDateFormat: dateFormat }}
      </div>
    }

    <div class="flex items-center">
      <div class="flex w-20 justify-end">
        <pr-automation-status
          [status]="automation.status"
          [errorMessage]="automation.errorMessage"
        />
      </div>

      <ng-content />
    </div>
  </div>
}
